import { Link } from 'gatsby'
import React from 'react'
import BlogPostPreview from './blog-post-preview'

function BlogPostPreviewGrid (props) {
  return (
    <div className=''>
      {props.title && <h2 className='tracking-wider mb-5 font-medium no-underline text-black uppercase tracking-wide text-base '>{props.title}</h2>}
      <ul className=''>
        {props.nodes &&
          props.nodes.map(node => (
            <li key={node.id}>
              <BlogPostPreview featuredList={props.featuredList} {...node} isInList />
            </li>
          ))}
      </ul>

      {/* {props.browseMoreHref && (
        <div className=''>
          <Link to='/blog/1'>Daha fazla</Link>
        </div>
      )} */}
    </div>
  )
}

BlogPostPreviewGrid.defaultProps = {
  title: '',
  nodes: [],
  browseMoreHref: ''
}

export default BlogPostPreviewGrid
